import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import Header from './components/Header';
import Footer from './components/Footer';
import LiveChat from './components/LiveChat';
import Home from './pages/Home';
import Shop from './pages/Shop';
import SonicWall from './pages/SonicWall';
import Antivirus from './pages/Antivirus';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/sonicwall" element={<SonicWall />} />
            <Route path="/antivirus" element={<Antivirus />} />
          </Routes>
        </main>
        <Footer />
        <LiveChat />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;